module.exports = __webpack_public_path__ + "static/media/country_si.1eb2411a.webp";